import { ArtistPresetsState } from './state';

export const artistPresetsInitialState: ArtistPresetsState = {};
